import useGetUserRole from '@forwardflow/hooks/customHooks/useGetUserRole'
import Icon from '@forwardflow/ui/Icons'
import { Link, useLocation } from 'react-router-dom'

export const SideNav = () => {
   const { data: userRoleData } = useGetUserRole()
   const isAgent = userRoleData?.roles.includes('Agent')
   const location = useLocation()
   return (
      <div className="flex flex-col flex-1 max-w-[280px]  xl:max-w-[350px] shrink-0 rounded-lg bg-primary/5 sticky top-0">
         <div className="flex items-center gap-4 px-10 py-5 font-medium">
            <Icon name="Gear" className="fill-white" />
            Account Settings
         </div>
         {!isAgent && (
            <>
               <Link
                  to={`/settings/user-management`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/user-management'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        User Management
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
               <Link
                  to={`/settings/organization-details`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/organization-details'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        Organization Details
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
               <Link
                  to={`/settings/business-hours`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/business-hours'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        Business Hours
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
               <Link
                  to={`/settings/appointment-timeframe`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/appointment-timeframe'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        Appointment Timeframe
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
            </>
         )}

         {!isAgent && (
            <>
               <Link
                  to={`/settings/stage-mapping`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/stage-mapping'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        Stage Mapping
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
               <Link
                  to={`/settings/billing`}
                  className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                     location.pathname === '/settings/billing'
                        ? 'bg-primary'
                        : ''
                  }`}
               >
                  <div className="flex items-center gap-x-2">
                     <span className="text-[14px] font-medium">
                        Billing and Subscription
                     </span>
                  </div>
                  <div className="flexc gap-x-3">
                     <Icon
                        name="arrow-down"
                        className="scale-90 -rotate-90 fill-white"
                     />
                  </div>
               </Link>
            </>
         )}
         {isAgent && (
            <Link
               to={`/settings/appointment-preference`}
               className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
                  location.pathname === '/settings/appointment-preference'
                     ? 'bg-primary'
                     : ''
               }`}
            >
               <div className="flex items-center gap-x-2">
                  <span className="text-[14px] font-medium">
                     Appointment Preference
                  </span>
               </div>
               <div className="flexc gap-x-3">
                  <Icon
                     name="arrow-down"
                     className="scale-90 -rotate-90 fill-white"
                  />
               </div>
            </Link>
         )}
         <Link
            to={`/settings/integration`}
            className={`flex items-center justify-between px-10 py-4 min-h-[76px] ${
               location.pathname === '/settings/integration' ? 'bg-primary' : ''
            }`}
         >
            <div className="flex items-center gap-x-2">
               <span className="text-[14px] font-medium">Integration</span>
            </div>
            <div className="flexc gap-x-3">
               <Icon
                  name="arrow-down"
                  className="scale-90 -rotate-90 fill-white"
               />
            </div>
         </Link>
      </div>
   )
}
